'use strict';

window.addEventListener('offline', function () {
  document.body.classList.add('offline');
});

window.addEventListener('online', function () {
  document.body.classList.remove('offline');
});
